"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgVolume2 = function SvgVolume2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M5.737 8.25l4.794-3.836A.75.75 0 0111.75 5v14a.75.75 0 01-1.219.586L5.737 15.75H2a.75.75 0 01-.75-.75V9A.75.75 0 012 8.25h3.737zm.732 1.336A.75.75 0 016 9.75H2.75v4.5H6a.75.75 0 01.469.164l3.781 3.026V6.56L6.469 9.586zm12.07-4.126A.75.75 0 0119.6 4.4c4.197 4.198 4.197 11.002 0 15.2a.75.75 0 01-1.06-1.06 9.25 9.25 0 000-13.08zm-3.53 3.53a.75.75 0 011.061-1.06 5.75 5.75 0 010 8.13.75.75 0 01-1.06-1.06 4.25 4.25 0 000-6.01z"
  }));
};

SvgVolume2.propTypes = process.env.NODE_ENV !== "production" ? {
  color: _propTypes["default"].string,
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
SvgVolume2.defaultProps = {
  color: "currentColor",
  size: "24"
};
var _default = SvgVolume2;
exports["default"] = _default;
module.exports = exports.default;